import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-795ba7cf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-wrap" }
const _hoisted_2 = { class: "slidebar-box" }
const _hoisted_3 = { class: "slider-store-box" }
const _hoisted_4 = { class: "menu-real-item-box" }
const _hoisted_5 = { class: "menu-icon-box" }
const _hoisted_6 = { class: "menu-icon-box" }
const _hoisted_7 = { class: "menu-real-item-box" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-icon-box" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"width":"3px","height":"3px","border-radius":"50%","background":"#999"} })
], -1))
const _hoisted_9 = { class: "submenu-box" }
const _hoisted_10 = {
  key: 0,
  class: "submenu-item-box"
}
const _hoisted_11 = { class: "submenu-title-box" }
const _hoisted_12 = { class: "submenu-body-box" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "main-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_MenuContainer = _resolveComponent("MenuContainer")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu_item_group = _resolveComponent("el-menu-item-group")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.store.name), 1),
      _createVNode(_component_el_menu, {
        "default-openeds": ['0', '1', '2', '3', '4', '5', '6', '7', '8'],
        class: "el-menu-vertical",
        "background-color": "#040848",
        "text-color": "#fff",
        "active-text-color": "#fff",
        router: true,
        "default-active": _ctx.activePath
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu.list, (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (item.show)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (item.isGroup || !item.children)
                      ? (_openBlock(), _createBlock(_component_el_menu_item, {
                          key: 0,
                          route: { name: item.aliasName },
                          index: item.aliasName
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_MenuContainer, {
                              activePath: _ctx.activePath,
                              modelValue: item
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_4, [
                                  _createElementVNode("div", _hoisted_5, [
                                    _createVNode(_component_el_icon, { size: 15 }, {
                                      default: _withCtx(() => [
                                        (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon)))
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _createElementVNode("span", null, _toDisplayString(item.name), 1)
                                ])
                              ]),
                              _: 2
                            }, 1032, ["activePath", "modelValue"])
                          ]),
                          _: 2
                        }, 1032, ["route", "index"]))
                      : (_openBlock(), _createBlock(_component_el_sub_menu, {
                          key: 1,
                          index: index + ''
                        }, {
                          title: _withCtx(() => [
                            _createElementVNode("div", _hoisted_6, [
                              _createVNode(_component_el_icon, { size: 15 }, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon)))
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _createElementVNode("span", null, _toDisplayString(item.name), 1)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_menu_item_group, null, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (citem, cindex) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                                    (citem.show)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          (!citem.isGroup || (citem.isGroup && citem.children?.length > 0))
                                            ? (_openBlock(), _createBlock(_component_el_menu_item, {
                                                index: citem.aliasName,
                                                route: { name: citem.aliasName },
                                                key: cindex
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_MenuContainer, {
                                                    activePath: _ctx.activePath,
                                                    modelValue: citem
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("div", _hoisted_7, [
                                                        _hoisted_8,
                                                        _createElementVNode("span", null, _toDisplayString(citem.name), 1)
                                                      ])
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["activePath", "modelValue"])
                                                ]),
                                                _: 2
                                              }, 1032, ["index", "route"]))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                }), 256))
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["index"]))
                  ], 64))
                : _createCommentVNode("", true)
            ], 64))
          }), 256))
        ]),
        _: 1
      }, 8, ["default-active"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subMenuList, (item, i) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
          (item.children && item.children.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(item.name), 1),
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (citem, c) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["submenu-body-item-box", { 'selected-box': _ctx.subActiveKey == citem.aliasName }]),
                      onClick: ($event: any) => (_ctx.gotoCitem(citem)),
                      key: c
                    }, [
                      _createVNode(_component_el_tooltip, {
                        disabled: citem.name.length <= 5,
                        content: citem.name,
                        placement: "top"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(citem.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["disabled", "content"])
                    ], 10, _hoisted_13))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_router_view, { class: "main-content" })
    ])
  ]))
}